<template>
  <span class="country-badge" :title="label">
    <i :class="['country-flag', normalized]" aria-hidden="true"><b v-if="normalized === 'gh'">★</b></i>
    <span>{{ normalized.toUpperCase() || '—' }}</span>
  </span>
</template>

<script>
export default {
  name: 'CountryBadge',
  props: { code: { type: String, default: '' } },
  computed: {
    normalized () { return String(this.code || '').trim().toLowerCase() },
    label () { return this.normalized === 'gh' ? '加纳 GH' : this.normalized === 'ng' ? '尼日利亚 NG' : this.code || '未知国家' }
  }
}
</script>

<style scoped>
.country-badge{display:inline-flex;align-items:center;gap:6px;font-weight:600;white-space:nowrap}.country-flag{position:relative;display:inline-flex;width:20px;height:14px;overflow:hidden;border:1px solid rgba(26,47,73,.16);border-radius:2px;box-shadow:0 1px 2px rgba(26,47,73,.14)}.country-flag.gh{background:linear-gradient(#ce1126 0 33.33%,#fcd116 33.33% 66.66%,#006b3f 66.66%)}.country-flag.gh b{position:absolute;inset:0;display:flex;align-items:center;justify-content:center;color:#111;font-size:8px;line-height:1}.country-flag.ng{background:linear-gradient(90deg,#008753 0 33.33%,#fff 33.33% 66.66%,#008753 66.66%)}
</style>
